export const LOGIN_URL = process.env.REACT_APP_URL_LOGIN
export const FORGOT_PASSWORD_URL = process.env.REACT_APP_URL_FORGOT_PASSWORD
export const encryptingKey = '+*Eltiempoads2022*+'
